export const getKeyByValue = (object: {}, value: any): string | undefined => {
	return Object.keys(object).find((key: string) => object[key] === value);
};

export const getStringLiteralValues = (object: {}): string[] => {
	return Object.keys(object).map((key: string) => object[key].toString());
};
